<template>
  <div class="tree" :class="{ expanded: isExpanded, 'tree-parent': hasChildren, 'tree-child': !hasChildren, disabled: disabled }" >
    <div class="node">
      <div class="title">
        <a-button type="link" v-if="hasChildren" @click="toggleExpand" class="switcher-icon" size="small">
          <DownOutlined v-if="isExpanded" />
          <UpOutlined v-else />
        </a-button>
        <span @click.stop="selectNode" :class="{ selected: isSelected }">
          {{ node.title }}
        </span>
        <span v-if="hasChildren" class="details">
          Grupo {{ node?.pos + 1 }}
        </span>
        <span v-else-if="node?.subtitle" class="details">
          • {{ node.subtitle }}
        </span>
      </div>
      <a-checkbox
        class="tree-checkbox"
        type="checkbox"
        :disabled="disabled"
        :checked="isChecked"
        @change="handleCheckboxChange"
      />
    </div>
    <div v-if="isExpanded">
      <TypificationTreeNode
        v-for="child in node.children"
        :key="child.key"
        :node="child"
        :expandedKeys="expandedKeys"
        :selectedKeys="selectedKeys"
        :checkedKeys="checkedKeys"
        :disabled="!isChecked"
        @update-checked="handleChildChecked"
        @update-selected="selectNode"
        @update-expanded="handleChildExpanded"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed, defineProps, defineEmits } from 'vue';
import TypificationTreeNode from '@/app/strategies/components/modals/typificationSelected/TypificationTreeNode.vue';
import { DownOutlined, UpOutlined } from "@ant-design/icons-vue";

interface TreeNodeProps {
  title: string;
  key: string;
  children?: TreeNodeProps[];
  class?: string;
  subtitle?: string;
  pos?: number;
}

const props = withDefaults(defineProps<{
  node: TreeNodeProps;
  expandedKeys: string[];
  selectedKeys: string[];
  checkedKeys: string[];
  disabled: boolean;
}>(),
{
  disabled: false,
});

const emit = defineEmits<{
  (e: 'update-checked', key: string, checked: boolean): void;
  (e: 'update-selected', key: string): void;
  (e: 'update-expanded', key: string): void;
}>();

const isExpanded = computed(() => props.expandedKeys.includes(props.node.key));
const hasChildren = computed(() => props.node.children && props.node.children.length > 0);
const isSelected = computed(() => props.selectedKeys.includes(props.node.key));
const isChecked = computed(() => props.checkedKeys.includes(props.node.key));

const toggleExpand = () => {
  emit('update-expanded', props.node.key);
};

const selectNode = (event: MouseEvent) => {
  emit('update-selected', props.node.key);
};

const handleCheckboxChange = (event: Event) => {
  const input = event.target as HTMLInputElement;
  console.log('handleCheckboxChange');
  emit('update-checked', props.node.key, input.checked);
};

const handleChildChecked = (key: string, checked: boolean) => {
  emit('update-checked', key, checked);
};

const handleChildExpanded = (key: string) => {
  emit('update-expanded', key);
};
</script>

<style lang="sass" scoped>
/* Añadir estilos básicos aquí */
.switcher-icon
  cursor: pointer
  color: rgba(38, 38, 38, 1)


// .expanded
//   font-weight: bold

.disabled
  background-color: rgba(0, 0, 0, 0.04) !important

// .selected
//   background-color: #e0e0e0

.node
  width: 100%
  display: flex
  justify-content: space-between

.tree
  &-parent
    background-color: #FFF7E6
    padding-right: 10px
    margin-bottom: 15px
    padding: 10px
    .title
      margin-bottom: 10px
      margin-left: 10px
    .tree-checkbox
      margin-right: 10px
  &-child
    background-color: rgba(255, 231, 186, 0.6)
    margin-left: 15px
    margin-bottom: 10px
    .title
      margin: 0 14px
    .node
      padding: 10px
    .tree-checkbox
      margin-right: 0

.details
  margin-left: 5px
  color: $gray-7
  font-style: oblique
</style>
